import { DUPE_API_URL } from '@dupe/common/constants'
import { useInfiniteQuery } from '@tanstack/react-query'
import fetcher from '~/src/lib/fetcher'

export interface Item {
  id: string
  hash: string
  shop_key: string
  image: string
  title: string
  width?: number
  height?: number
}

export type ApiResponse<Data> = {
  data: Data[]
}

const useFetchDisoverFeed = ({
  limit = 100,
  multiplier = 1,
  enabled = false,
}) => {
  const fetchUrl = `${DUPE_API_URL}/api/discover-home`

  return useInfiniteQuery<
    ApiResponse<Item>,
    Error,
    Item[],
    (string | number)[],
    number
  >({
    queryKey: ['discover', limit],
    queryFn: ({ pageParam = 0 }) =>
      fetcher<ApiResponse<Item>>(fetchUrl, {
        method: 'GET',
        dataOrParams: { limit, offset: pageParam, multiplier },
      }),
    getNextPageParam: (lastPage, allPages) => {
      if (lastPage?.data?.length < limit) return undefined
      const currentTotalItems = allPages.reduce(
        (acc, page) => acc + page.data.length,
        0
      )
      return currentTotalItems
    },
    initialPageParam: 0,
    enabled,
    select: (data) => {
      return data.pages.flatMap((page) => page.data)
    },
  })
}

export default useFetchDisoverFeed
